module.exports = __webpack_public_path__ + "img/10_maska_setka-vypuklaya.a5822a5.svg";